import React, { memo } from 'react';
import { useSecondStep } from './useSecondStep';
import { ProjectTeamInvite } from '../../../TemporaryConmonents/ProjectTeam/ProjectTeamInvite/ProjectTeamInvite';

interface SecondStepProps {
    onLoaderChange: (value: boolean) => void;
}

export const SecondStep = memo(({ onLoaderChange }: SecondStepProps) => {
    const { onEmployersListSet, employersList } = useSecondStep(onLoaderChange);

    return (
        <ProjectTeamInvite onEmployersListSet={onEmployersListSet} employersList={employersList} />
    );
});
